import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ExternalTransferServiceProxy, OutgoingTransferServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: "ngx-status-card",
  styleUrls: ["./status-card.component.scss"],
  template: `
    <nb-card (click)="goTo(destination)">
      <div class="icon-container">
        <div class="icon status-primary">
          <ng-content></ng-content>
        </div>
      </div>

      <div class="details">
        <div class="title h5">{{ title }}</div>
      </div>
    </nb-card>
  `,
})
export class StatusCardComponent implements AfterViewInit {
  @Input() title: string;
  @Input() destination: string;
  // @Input() count: number | undefined;

  // counter: number;

  constructor(
    private _externalTransferService: ExternalTransferServiceProxy,
    private _outgoingTransferService: OutgoingTransferServiceProxy,
    private router: Router
  ) {
    // console.log(this.counter);
  }

  ngAfterViewInit(): void {
    // if (this.destination == "IncomeTransferNotAccepted") {
    //   this._externalTransferService.getAllCount().subscribe((count) => {
    //     this.counter = count;
    //   });
    // } else if (this.destination == "OutgoingTransfers") {
    //   this._outgoingTransferService.getAllRejectedCount().subscribe((count) => {
    //     this.counter = count;
    //   });
    // }
  }

  goTo(destination) {
    if (destination != undefined) {
      switch (destination) {
        case "OutgoingTransfers":
          this.router.navigateByUrl("/app/transfer/create-outgoing-transfer");
          break;
        case "IncomeTransfers":
          this.router.navigateByUrl("/app/transfer/create-income-transfer");
          break;
        case "NoneReceivedTransfer":
          this.router.navigateByUrl("/app/transfer/direct-transfer");
          break;
        case "SendTransfers":
          this.router.navigateByUrl("/app/transfer/sending-outgoing");
          break;
        case "RejectedOutgoingTransfers":
          this.router.navigateByUrl(
            "/app/transfer/rejected-outgoing-transfers"
          );
          break;
        case "IncomeTransferNotAccepted":
          this.router.navigateByUrl(
            "/app/transfer/income-transfer-notAccepted"
          );
          break;
        case "ExchangeCurrency":
          this.router.navigateByUrl("/app/exchange-currency/create");
          break;
        case "Treasury":
          this.router.navigateByUrl("/app/treasury/treasury-action");
          break;
        case "Setting":
          this.router.navigateByUrl("/app/setting");
          break;
        case "Auth":
          this.router.navigateByUrl("/app/security");
          break;
        case "Tenants":
          this.router.navigateByUrl("/app/admin/tenant");
          break;
        case "Link Tenants":
          this.router.navigateByUrl("/app/admin/link-tenant-company");
          break;
        default:
          break;
      }
    }
  }
}
